import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Container, Link } from "../styled.ts";
import { Typography } from "../typography/index.tsx";

const isExternalUrl = (url: string) =>
  /^(https?:|mailto:|tel:)/.test(url);

const LinkButton = ({
  url = "#",
  icon = <></>,
  background = "#fff",
  border = "solid 1px #fff",
  color = "#202020",
  linkText = "sample text",
}) => {
  const disabled = !url || url === "#";
  const external = !disabled && isExternalUrl(url);
  const newTab = !disabled && /^https?:/.test(url);

  const navProps = disabled
    ? {}
    : external
    ? { as: "a" as const, href: url, ...(newTab ? { target: "_blank", rel: "noopener noreferrer" } : {}) }
    : { as: RouterLink, to: url };

  return (
    <Container
      gap="10px"
      background={background}
      border={border}
      radius="100px"
      padding="5px 20px"
      alignItems="center"
      justifyContent="center"
      style={{ cursor: disabled ? "default" : "pointer", textDecoration: "none" }}
      {...navProps}
    >
      {icon}
      <Typography
        tag="p"
        fontFamily="Neue Montreal"
        fontSize={"14px"}
        fontWeight={400}
        lineHeight={"21px"}
        letterSpacing={"0.02em"}
        color={color}
        textAlign="center"
        whiteSpace="nowrap"
      >
        <Link as="span" active>
          {linkText}
        </Link>
      </Typography>
    </Container>
  );
};

export default LinkButton;
